var _excluded = ["action", "permanentView", "items", "listProps", "onActiveItemChange", "viewWidth"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Container } from 'semantic-ui-react';
import ListViewList from "./ListViewList";
import ListViewView from "./ListViewView";
import "./ListView.css";

// Composant qui permet d'afficher une liste
// ainsi qu'une vue de chaque élément en détail.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ListView = function ListView(props) {
  var _item2;
  var action = props.action,
    permanentView = props.permanentView,
    items = props.items,
    listProps = props.listProps,
    onActiveItemChange = props.onActiveItemChange,
    viewWidth = props.viewWidth,
    rest = _objectWithoutPropertiesLoose(props, _excluded);

  // id of horeving item
  var _React$useState = React.useState(null),
    activeItem = _React$useState[0],
    setActiveItem = _React$useState[1];
  // if the item has a view, we'll display it.
  var _React$useState2 = React.useState(false),
    hasAtLeastOneView = _React$useState2[0],
    setHasAtLeastOneView = _React$useState2[1];
  var item = null;

  // Deduction de l'item actif en fonction des props
  if (permanentView && _.isNil(activeItem) && !_.isEmpty(items)) {
    item = _.first(items);
  } else {
    item = _.find(items, function (_ref) {
      var identifiant = _ref.identifiant,
        key = _ref.key;
      return identifiant === activeItem || key === activeItem;
    });
  }
  var actualActiveItemId = React.useMemo(function () {
    var _item;
    return (_item = item) == null ? void 0 : _item.identifiant;
  }, [item]);
  var handleActiveItemChange = function handleActiveItemChange(id) {
    setActiveItem(id);
    if (onActiveItemChange) {
      onActiveItemChange(id);
    }
  };
  var handleLeave = function handleLeave() {
    setActiveItem(null);
    if (onActiveItemChange) {
      onActiveItemChange(null);
    }
  };
  React.useEffect(function () {
    setHasAtLeastOneView(_.some(items, function (_ref2) {
      var view = _ref2.view;
      return !_.isNil(view);
    }));
  }, [items]);
  var classNames = 'listview';
  if (_.isNil(action)) {
    classNames += ' noAction';
  }
  if (hasAtLeastOneView) {
    classNames += ' viewable';
  }
  if (!_.isNil(actualActiveItemId)) {
    classNames += ' viewing';
  }
  return /*#__PURE__*/_jsx(Grid, Object.assign({
    style: {
      width: 'fit-content'
    },
    className: classNames,
    onMouseLeave: handleLeave,
    celled: true
  }, rest, {
    children: /*#__PURE__*/_jsxs(Grid.Row, {
      style: {
        padding: 0
      },
      children: [/*#__PURE__*/_jsxs(Grid.Column, {
        style: {
          maxHeight: 285,
          width: 280,
          padding: 0,
          display: 'flex',
          flexDirection: 'column'
        },
        children: [/*#__PURE__*/_jsx(Container, {
          style: {
            overflowY: 'auto',
            overflowX: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            margin: 0,
            padding: 0,
            direction: 'rtl'
          },
          children: /*#__PURE__*/_jsx(Container, {
            style: {
              display: 'flex',
              direction: 'ltr',
              flex: 1,
              margin: 0,
              padding: 0
            },
            children: /*#__PURE__*/_jsx(ListViewList, Object.assign({
              items: items,
              activeItem: actualActiveItemId
            }, hasAtLeastOneView && {
              onActiveItemChange: handleActiveItemChange
            }, listProps))
          })
        }), !_.isNil(action) && /*#__PURE__*/_jsx(Container, {
          style: {
            padding: 0,
            width: '100%'
          },
          children: /*#__PURE__*/React.isValidElement(action) ? action : /*#__PURE__*/React.createElement(action)
        })]
      }), hasAtLeastOneView && !_.isNil(actualActiveItemId) && /*#__PURE__*/_jsx(Grid.Column, {
        style: {
          width: viewWidth,
          maxHeight: 285,
          maxWidth: 700,
          padding: '0 15px',
          flex: 1
        },
        children: /*#__PURE__*/_jsx(ListViewView, Object.assign({}, (_item2 = item) == null ? void 0 : _item2.view))
      })]
    })
  }));
};
ListView.handledProps = ["action", "items", "listProps", "onActiveItemChange", "permanentView", "viewWidth"];
ListView.propTypes = {
  // Action affiché sous la liste
  action: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  // Si on veut forcément une vue active à l'affichage
  permanentView: PropTypes.bool,
  // Liste des items à afficher avec pour chaque item une view potentiel.
  items: PropTypes.arrayOf(PropTypes.shape({
    identifiant: PropTypes.number,
    key: PropTypes.string,
    title: PropTypes.node,
    subtitle: PropTypes.node,
    view: PropTypes.shape({
      title: PropTypes.node,
      subtitle: PropTypes.node,
      descriptionTitle: PropTypes.node,
      description: PropTypes.node
    })
  })),
  // eslint-disable-next-line react/forbid-prop-types
  listProps: PropTypes.object,
  // Callback au survol des items qui renvoit l'identifiant ou la key.
  onActiveItemChange: PropTypes.func,
  // Largeur fixé pour toutes les views
  viewWidth: PropTypes.number
};
ListView.defaultProps = {
  action: null,
  permanentView: false,
  items: null,
  listProps: null,
  onActiveItemChange: null,
  viewWidth: null
};
export default ListView;